import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { BottomSheet, Drawer } from '@/shared/design-system';

import { LegendContent } from './table-legend-modal.styled';

export type TableLegendModalProps = {
  title: string | undefined;
  description: string | undefined;
};

export const TableLegendModal = () => {
  const isMobile = useIsMobile();
  const { open, handleClose, props } = useGlobalModal('TABLE_LEGEND_MODAL');

  const title = `Table Legend: ${props?.title}`;
  const content = <LegendContent>{props?.description ?? ''}</LegendContent>;

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) handleClose();
  };

  if (isMobile) {
    return (
      <BottomSheet open={open} onOpenChange={handleOpenChange} title={title} showClose>
        {content}
      </BottomSheet>
    );
  }

  return (
    <Drawer open={open} onOpenChange={handleOpenChange} title={title} showClose>
      {content}
    </Drawer>
  );
};
